export { default as Shoutout } from './Shoutout';
